<template>
  <div class="modal modal--agreement-create fade fixed-end" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Agreement Title</label>
            <input
              name="name"
              v-model="newAgreement.title"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
            />
            <help-block field="name" />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary">
              Save
            </c-button>
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
    </div>
    <!-- /.drawer-contents -->
  </div>
  <!-- /.drawer -->
</template>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { http } from 'utils'
import { Selectize, LaddaButton } from 'components/form/input'
import Datepicker from 'vuejs-datepicker'
import $ from 'jquery'
import { notify } from 'utils'
import { unset, cloneDeep } from 'lodash'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  $_veeValidate: {
    validator: 'new', // give me my own validator scope.
  },
  props: ['title', 'budget', 'mode'],
  extends: CModal,
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      newAgreement: {},
    }
  },

  mounted() {},

  computed: {},

  methods: {
    ...mapActions('projectAgreement', ['addSingle']),

    handleSave() {
      return this.handleAdd()
    },

    async handleAdd() {
      if (!(await this._validate())) {
        notify.error('Form validation failed, please check your inputs and try again.')
        return Promise.reject()
      }

      try {
        return this.addSingle(this.newAgreement)
          .then(response => {
            //Redirect to new opp
            this.close()
            this.$emit('created', response.data)
          })
          .catch(error => {
            if (error.response.status === 422) {
              notify.error('Form validation failed, please check your inputs and try again.')
            } else {
              console.error(error)
              notify.error('Failed to create agreement, please try again.')
            }
          })
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>
